import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { AccessService } from '@cm/ui-modules';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
@Injectable({
  providedIn: 'root',
})
export class FileDownloadService {
  private readonly http = inject(HttpClient);
  private readonly checkAccess = inject(AccessService);

  downloadFile(data: any): Observable<HttpResponse<ArrayBuffer>> | null {
    if (!this.checkAccess.isLogged()) return null;

    const access_token = this.checkAccess.getUser()?.access_token;
    const headers = new HttpHeaders().append('Authorization', `Bearer ` + access_token);
    return this.http.get(environment.exports.uri + '/' + data.fileName, {
      observe: 'response',
      responseType: 'arraybuffer',
      headers,
    });
  }
}
